<template lang="html">
  <div class="centerx">
    <vs-popup title="" :active.sync="isPopupActive" class="mw-1/2">
      <div class="container">
        <div class="vx-col mb-base w-full">
          <div class="vx-row w-full center ml-1">
            <span>
              <vs-icon icon="business" size="75px" color="black"></vs-icon>
            </span>
          </div>
          <div class="vx-row center ml-1">
            <div class="vx-col title f-color">
              {{ society.name }}
            </div>
          </div>
          <div class="vx-row center ml-1">
            <div class="vx-col mt-2 center-align f-color">
                Siret : {{ society.siret || " " }}
            </div>
            <div class="vx-col mt-2 center-align f-color">
                Type : {{ getSocietyType(society.is_ecommerce) || " " }}
            </div>
            <div class="vx-col mt-2 center-align f-color">
              <vs-chip
                style="width: 80px"
                :color="getContractStatusColor(society.status)">{{
                getStatus(society.status)
              }}</vs-chip>
            </div>
          </div>
          <div class="vx-row w-full ml-1 t-border">
            <div class="vx-col w-1/2 mt-2">
              Date de création:
              <span class="f-color">{{
                getDateToFrenchFormat(society.creation_timestamp)
              }}</span>
            </div>
            <div class="vx-col w-1/2 mt-2">
              Commercial:
              <span class="f-color" v-if="commercialSociety"
                >{{ commercialSociety.firstname }}
                {{ commercialSociety.lastname }}</span
              >
              <span class="f-color" v-else> Aucun</span>
            </div>
          </div>
          <div class="vx-row w-full center ml-1 mt-2">
            <div class="vx-col w-1/2 mt-2">
              Dernière Mise à Jour:
              <span class="f-color">{{
                getDateToFrenchFormat(society.last_update_timestamp)
              }}</span>
            </div>
            <div class="vx-col w-1/2 mt-2">
              Origine :
              <span class="f-color ml-1">
                {{ getSocietyOrigin(society.origin) }}</span
              >
            </div>
          </div>
          <div class="vx-row w-full ml-1 mt-2 t-border">
            <div class="vx-col mt-2">
              <div class="w-full">Coordonnées:</div>
              <div class="w-full mt-2 center-align f-color">
                <vs-icon
                  class="mr-2"
                  icon="room"
                  size="medium"
                  color="black"
                ></vs-icon>
                {{ completeAdress }}
              </div>
              <div class="w-full center-align f-color">
                <vs-icon
                  class="mr-2"
                  icon="phone"
                  size="medium"
                  color="black"
                ></vs-icon>
                {{ society.phone }}
              </div>
              <div class="w-full center-align f-color">
                <vs-icon
                  class="mr-2"
                  icon="gavel"
                  size="medium"
                  color="black"
                ></vs-icon>
                {{ society.tva || " " }}
              </div>
            </div>
          </div>
          <div class="vx-row center_div t-border">
            <vs-table :data="relatedUser" v-if="relatedUser">
              <template slot="thead">
                <vs-th>Civilité</vs-th> <!-- Madame ou Monsieur -->
                <vs-th>Prénom</vs-th> <!-- Prénom -->
                <vs-th>Nom</vs-th> <!-- Nom -->
                <vs-th>Fonction</vs-th> <!-- Commercial ou Facturation -->
                <vs-th>Email</vs-th> <!-- Email -->
                <vs-th>Téléphone</vs-th> <!-- Téléphone -->
                <vs-th>Accès Dashboard</vs-th>
              </template>

              <template slot-scope={data}>
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>{{ getUserCivility(data[indextr].civility) }}</vs-td> <!-- Madame ou Monsieur -->
                  <vs-td>{{ data[indextr].firstname }}</vs-td> <!-- Prénom -->
                  <vs-td>{{ data[indextr].lastname }}</vs-td> <!-- Nom -->
                  <vs-td>{{ getUserTitle(data[indextr].type) }}</vs-td> <!-- Commercial ou Facturation -->
                  <vs-td>{{ data[indextr].email }}</vs-td> <!-- Email -->
                  <vs-td>{{ data[indextr].phone }}</vs-td> <!-- Téléphone -->
                  <vs-td>{{ getUserDashboardAccess(data[indextr].hasAccess) }}</vs-td> <!-- hasAccess to Dashboard -->
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import {Collaborator} from "@/entities/Collaborator";
export default {
	name: "ContractSocietyInfoPopup",
	props: {
		society: Object,
		popupActive: Boolean,
		router: Object,
		apiUrl: String,
	},
	mixins: [dbFieldConvertor, utilsMixin],
	computed: {
		completeAdress: function() {
			return (
				this.$props.society.adress + " " +
        (this.$props.society.adress_complement || "") + " " +
        this.$props.society.city + " " + (this.$props.society.postal_code || "") + ", " +
        this.$props.society.country
			);
		},
		societyId: function(){
			return this.$props.society.id;
		}
	},
	created(){
		this.refreshContact();
	},
	watch: {
		society: function(data) {
			this.getAllRelatedUser(data.id);
			this.getCommercialSociety(data.commercial_id);
		},

		relatedUser: function(data) {
			this.commercialContact = this.getCommercialContact(data);
			this.billingContact = this.getBillingContact(data);
		},
		popupActive: function(){
			this.isPopupActive = this.popupActive;
		},
		isPopupActive: function(){
			this.$emit("update:popupActive", this.isPopupActive);
		}
	},

	data() {
		return {
			relatedUser: null,
			commercialSociety: null,
			commercialContact: null,
			billingContact: null,
			isPopupActive: this.popupActive
		};
	},

	methods: {
		getAllRelatedUser(societyId) {
			this.$http
				.get("users/getuserforsociety/" + societyId)
				.then(res => {
					this.relatedUser = res.data;
				})
				.catch(err => console.error(err));
		},
		/**
		 * Fetch the commercial in charge of the society
		 */
		getCommercialSociety(commercialId) {
			Collaborator.getCommercial(commercialId, (err, res) => {
				this.commercialSociety = res;
			});
		},

		refreshContact(){
			//console.log("Refreshing Contacts");
			this.getAllRelatedUser(this.societyId);
		},
	}
};
</script>

<style scoped>
.center {
  justify-content: center;
}

.right-elem {
  justify-content: flex-end;
}

.bg-color {
  background: #35e9fd !important;
}

.t-border {
  border-top: 1px solid grey;
}

.l-border {
  border-left: 1px solid grey;
}

.title {
  font-weight: 600;
  font-size: 2em;
}

.f-color {
  color: black;
}

.center-align {
  display: flex;
  align-items: center;
}

.no-width-limit{
  width: unset;
}
</style>
